import { store } from '../../../../resources/frontend/js/store/index';
import convertSize from '@mixins/utils/convert-size';
import scrollToSelector from '@mixins/utils/scroll-to-selector';

/**
 * Search for anchors and add click event listener to scroll to the target
 * @param anchors {NodeList}
 */
export default anchors => {
    if (anchors.length === 0) return;

    for (const anchor of anchors) {
        anchor.addEventListener('click', () => {
            const startCtaIsActive = store.getters['component/getOrganismValue']('startCta', 'isActive');
            const target = `.${anchor.getAttribute('data-anchor-target')}`;
            const parsedTarget = target.match(/([A-Z]?[^A-Z]*)/g).slice(0, -1).join('-').toLowerCase();
            const offset = convertSize(-40, true, true);

            if (parsedTarget === '.start-cta' && !startCtaIsActive) {
                scrollToSelector('.questions', offset);
                return;
            }

            if (parsedTarget === '.quiz') {
                scrollToSelector('.questions', offset);
                return;
            }

            scrollToSelector(parsedTarget, offset);
        });
    }
};
